module.exports = __webpack_public_path__ + "img/bg.4354fa7a.jpeg";